module.exports = __webpack_public_path__ + "static/asymmetry-1472ddcbace5421255fb7e0c0e532ce3.jpg";